<div class="container-fluid">
  <page-header-search
  [isSearchInput]="false"
  [pageTitleValue]="pageTitle"
></page-header-search>

  <div *ngIf="filteredReports.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <div class="table-title-actions">
          <h3 class="title mb-0">All Reports</h3>
        </div>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <div class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let th of theadArray">{{ th.text | uppercase }}</th>
              <th>Speciality Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="pointer"
              *ngFor="let item of filteredReports"
              (click)="onGetReport(item)"
            >
              <td>
                <span>{{ item.name }}</span>
              </td>
              <td>
                <span>{{ item.arName }}</span>
              </td>
              <td>
                <span>{{ item.rank }}</span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default">
                    <input
                      [checked]="item.isActive"
                      type="checkbox"
                      id="active-check"
                      (change)="onSpecialityActiveChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default">
                    <input
                      [checked]="item.isAnonymous"
                      type="checkbox"
                      id="active-check"
                      (change)="onSpecialityAnonymousChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <button
                  class="btn btn-icon btn-outline-success mr-2"
                  type="button"
                  placement="top"
                  tooltip="Edit"
                  [routerLink]="['edit', item.id]"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"> </i>
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-outline-primary mr-2"
                  type="button"
                  placement="top"
                  tooltip="Push"
                  (click)="onPushNotification($event, item)"
                >
                  <span class="btn-inner--icon">
                    <i class="far fa-bell"> </i>
                  </span>
                </button>
                <button
                  *ngIf="item.link"
                  class="btn btn-icon btn-outline-default"
                  type="button"
                  (click)="onCopyHandler(val, pop)"
                  #pop="bs-popover"
                  popover="copied"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-copy"> </i>
                  </span>
                </button>
                <input
                  #val
                  [value]="item.link"
                  style="opacity: 0; display: block; height: 0px"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="fab-btn" [routerLink]="'add'">
  <i class="ni ni-fat-add"></i>
</div>
